import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weekdayName'
})
export class WeekdayNamePipe implements PipeTransform {
  transform(dayNumber: number, ...args: unknown[]): unknown {
    const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

    // Validate the input to ensure it's a valid day number
    if (dayNumber < 0 || dayNumber > 6 || isNaN(dayNumber)) {
      return 'Invalid Day';
    }

    return weekdays[dayNumber];
  }
}
